<script>
import { Line } from "vue-chartjs";
import { mapState, mapMutations } from "vuex";
export default {
  extends: Line,
  props: ["chartData", "options"],
  computed: {
    ...mapState({
      isCollapse: state => state.isSidebarCollapse
    })
  },
  watch: {
    chartData(val) {
      this.addPlugin({
        beforeInit: (chart) => {
          chart.data.labels.forEach(function (e, i, a) {
            if (/ |\n/.test(e)) {
              a[i] = e.split(/ /)
            }
          })
        }
      });
      this.renderChart(val, this.options);
    },
    isCollapse() {
      this.renderChart(this.chartData, this.options);
    }
  },
};
</script>

<style>
</style>
